import React, {Component} from 'react';
import FormIntegrar from './FormIntegrar';
import {reset} from 'redux-form';
import {connect} from 'react-redux';

import CadastrarEstabelecimentoApi from '../../../logicas/Validador/CadastrarEstabelecimentoApi'


class IntegrarFormPage extends Component {
  render() {
    const dispararCadastroEstabelecimento = (values) =>
      new Promise(resolve => {
        this.props.cadastrarEstabelecimento(values, resolve, reset);
      });

    return (
      <div>
        <section className="py-5">
          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h1>Integre seu sistema</h1>
              </div>
            </div>
          </div>

          <div className="container">
            <p>
              Os estabelecimentos, produtoras e promotoras de eventos podem integrar seus sistemas de vendas online
              diretamente com o validador da CIE por meio de API's, agilizando e automatizando o
              processo de vendas.
            </p>
            <p>Para realizar esta integração, é necessário efetuar o cadastro abaixo.</p>

            {/* <p>
              Para mais informações, acesse nossa <a
              href="https://docs.meiaentrada.org.br/#59799e4a-9895-7d9e-8168-df50862dc0a5"
              target="_blank" rel="noopener noreferrer">documentação</a>.
            </p> */}

            <div className="row justify-content-center mt-5">

              <div className="form-style col-md-10 col-lg-8 col-xl-6 py-4 px-5">
                <FormIntegrar onSubmit={dispararCadastroEstabelecimento}/>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return state
};

const mapDispatchToProps = dispatch => {
  return {
    cadastrarEstabelecimento: (values, resolve, reset) => {
      dispatch(CadastrarEstabelecimentoApi.cadastrarEstabelecimento(values, resolve, reset))
    }
  }
};

const IntegrarFormPageContainer = connect(mapStateToProps, mapDispatchToProps)(IntegrarFormPage);

export default IntegrarFormPageContainer


// WEBPACK FOOTER //
// ./src/components/views/Validador/IntegrarFormPage.js